import { ObjectNames, ObjectValues, ScreenNames, sendEvent } from "@swiggy-private/portal-dineout-context";
import type { IEventPayload } from "@swiggy-private/portal-dineout-context";
import { getV2ConfigFlags } from "@swiggy-private/portal-dineout-ui";
import { UserCategory } from "types";
import { ICurtainRaiserAnalyticsParams } from "./types";

const getAnalyticsData = ({
    eventFn,
    tableContext,
    restaurantName,
    isUserHost,
    config,
    objectValue,
}: ICurtainRaiserAnalyticsParams): IEventPayload => {
    const { restaurantId = "", tableId = "" } = tableContext;
    const { isV2, isV2InApp } = getV2ConfigFlags(config);
    const theme = isV2InApp ? config?.themeInfo?.theme : undefined;
    return {
        eventFn,
        screenName: ScreenNames.HOME,
        objectName: ObjectNames.HOME,
        objectValue,
        objectPosition: "1",
        extraParams: {
            restaurant_id: restaurantId,
            restaurant_name: restaurantName,
        },
        context: JSON.stringify({
            "user-category": isUserHost ? UserCategory.PRIMARY : UserCategory.SECONDARY,
            table_id: tableId,
            is_v2_config: isV2,
            theme,
        }),
    };
};

export const sendPageImpressionEvent = (args: ICurtainRaiserAnalyticsParams) => {
    sendEvent(getAnalyticsData({ ...args, objectValue: ObjectValues.HOME }));
};

export const sendSwipeUpEvent = (args: ICurtainRaiserAnalyticsParams) => {
    sendEvent(getAnalyticsData({ ...args, objectValue: ObjectValues.CURTAIN_SWIPE_UP }));
};
